import { useState } from 'react';
import {
  Breadcrumb,
  Button, Card, Container, Radios,
} from 'nhsuk-react-components';
import useUser from 'hooks/useUser';
import { useNavigate, useSearchParams } from 'react-router-dom';
import adminCards from 'utils/adminCards.ts';
import { getTeamsForAdmin } from 'utils/adminUtils';
import TeamRadioItem from 'components/TeamRadioItem';

function AdminSelectTeamPage() {
  const [searchParams] = useSearchParams();
  const { roles } = useUser();
  const navigate = useNavigate();
  const foundCard = adminCards.find(
    (c) => c.fn === searchParams.get('fn')?.trim(),
  );
  const teamIds = getTeamsForAdmin(roles, foundCard);

  const [selectedTeam, setSelectedTeam] = useState('');
  const [noTeamIdSelected, setNoTeamIdSelected] = useState(false);

  const handleSubmit = () => {
    if (!selectedTeam) {
      setNoTeamIdSelected(true);
      return;
    }

    const actionParam = searchParams.get('fn');
    const actionPath = actionParam?.trim();

    navigate(`/admin/${selectedTeam}/${actionPath}`);
  };

  return (
    <Container>
      <div className="nhsuk-u-margin-bottom-6">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/admin">
            Admin home
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span aria-current="page">Choose team</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Card>
        <>
          <main
            id="maincontent"
            className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3"
          >
            {foundCard?.title ?? 'Team select'}
          </main>
          <p>
            Choose a team then select Continue.
          </p>
        </>
      </Card>

      <Card>

        <div className="form-field-group nhsuk-u-margin-bottom-2">
          {teamIds.length > 0 && (
            <Radios
              legend="Choose a team"
              legendProps={{
                size: 'm',
              }}
              name="team-selection"
              onChange={(e) => {
                setNoTeamIdSelected(false);
                setSelectedTeam((e.target as HTMLInputElement).value);
              }}
              error={
                  noTeamIdSelected ? 'Choose a team to continue' : undefined
                }
            >
              {teamIds.map((teamId) => (
                <TeamRadioItem key={teamId} teamId={teamId} />
              ))}
            </Radios>
          )}

        </div>
      </Card>

      <Button onClick={handleSubmit}>Continue</Button>
    </Container>
  );
}

export default AdminSelectTeamPage;
